import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllPromocodeUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllPromocode/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromocodeUser = data;

    // console.log('Сервер вернул данные по Promocode ---- ',response.data);


    return AllPromocodeUser;
};


const setActivePromocode = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setPromocodeActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromocodeUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Promocode  - ',response);


    return AllPromocodeUser;
};



const setDeletedPromocode = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setPromocodeDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromocodeUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Promocode  - ',response);


    return AllPromocodeUser;
};




const setUpdatePromocode = async (dataPromocodeUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setPromocodeUpdate/'),{
        dataPromocodeUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromocodeUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Promocode  - ',dataPromocodeUpdate,response);


    return AllPromocodeUser;
};


const setSaveNewPromocode = async (dataPromocodeUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewPromocode/'),{
        dataPromocodeUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllPromocodeUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Promocode  - ',response, dataPromocodeUpdate);


    return AllPromocodeUser;
};

Mock.onGet('/api/reference/getAllPromocode').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllPromocodeUser = await getAllPromocodeUser();
    // console.log('С сервера пришло - ', AllPromocodeUser);

    // if (!AllPromocodeUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllPromocodeUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromocodeUser,
    ]


})


Mock.onPost('/api/reference/setActivePromocode').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPromocodeUser = await setActivePromocode(id,val);

    // if (!AllPromocodeUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPromocodeUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromocodeUser,
    ]


})

Mock.onPost('/api/reference/setDeletedPromocode').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPromocodeUser = await setDeletedPromocode(id,val);

    // if (!AllPromocodeUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPromocodeUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromocodeUser,
    ]


})


Mock.onPost('/api/reference/setUpdatePromocode').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataPromocodeUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Promocode = await setUpdatePromocode(dataPromocodeUpdate);

    // console.log('Серовер вернул данные ',AllPromocodeUser);

    // if (!Promocode) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Promocode) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Promocode,
    ]


})


Mock.onPost('/api/reference/setSaveNewPromocode').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataPromocodeUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Promocode = await setSaveNewPromocode(dataPromocodeUpdate);

    // console.log('Серовер вернул данные ',AllPromocodeUser);

    // if (!Promocode) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Promocode) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Promocode,
    ]
})